<script setup lang="ts">
import { isMobile } from '@/utils/isMobile'

defineProps({
    size: {
        type: String,
        default: 'x-small'
    }
})
const shareUiComponent = computed(() => {
    if (isMobile.any()) {
        return 'v-bottom-sheet'
    }
    return 'v-dialog'
})

const currentURL: Ref<string> = ref(location?.href || '')

const shareToFacebook = () => {
    window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(currentURL.value),
        'facebook-share-dialog',
        'width=626,height=436'
    )
    return false
}

const shareToTwitter = () => {
    window.open(
        'https://twitter.com/intent/tweet?text=' + encodeURIComponent(currentURL.value),
        'twiter-share-dialog',
        'width=626,height=436'
    )
    return false
}

const shareToLinkedin = () => {
    window.open(
        'https://www.linkedin.com/sharing/share-offsite/?url=' +
            encodeURIComponent(currentURL.value),
        'linkedin-share-dialog',
        'width=626,height=736'
    )
    return false
}

const copyLink = () => {
    navigator.clipboard.writeText(currentURL.value)
}
</script>

<template>
    <component :is="shareUiComponent" max-width="500">
        <template v-slot:activator="{ props: dialogActivatorProps }">
            <v-btn
                v-bind="dialogActivatorProps"
                class="ml-2"
                icon="mdi-tray-arrow-up"
                :size="size"
            ></v-btn>
        </template>

        <template v-slot:default="{ isActive }">
            <v-card>
                <v-card-title class="d-flex justify-space-between">
                    <span class="title text-capitalize">{{ $t('share') }}</span>
                    <v-btn
                        icon="mdi-close"
                        color="grey-darken-4"
                        @click="isActive.value = false"
                        size="x-small"
                        title="Share this link"
                    ></v-btn>
                </v-card-title>
                <v-card-text>
                    <p id="share-btns-wrapper" class="text-center">
                        <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    depressed
                                    fab
                                    light
                                    icon="mdi-facebook"
                                    v-bind="props"
                                    @click="shareToFacebook"
                                >
                                </v-btn>
                            </template>
                            <span>{{ $t('shareToFacebook') }}</span>
                        </v-tooltip>

                        <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    depressed
                                    fab
                                    light
                                    icon="mdi-linkedin"
                                    v-bind="props"
                                    @click="shareToLinkedin"
                                >
                                </v-btn>
                            </template>
                            <span>{{ $t('shareToLinkedin') }}</span>
                        </v-tooltip>
                        <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    depressed
                                    fab
                                    light
                                    icon="mdi-twitter"
                                    v-bind="props"
                                    @click="shareToTwitter"
                                >
                                </v-btn>
                            </template>
                            <span>{{ $t('shareToTwitter') }}</span>
                        </v-tooltip>
                        <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    depressed
                                    fab
                                    light
                                    icon="mdi-email"
                                    link
                                    :href="`mailto:?body=${currentURL}`"
                                    v-bind="props"
                                >
                                </v-btn>
                            </template>
                            <span>{{ $t('shareViaEmail') }}</span>
                        </v-tooltip>
                        <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    depressed
                                    fab
                                    light
                                    icon="mdi-content-copy"
                                    @click="copyLink"
                                    v-bind="props"
                                >
                                </v-btn>
                            </template>
                            <span>{{ $t('copyLink') }}</span>
                        </v-tooltip>
                        <v-spacer></v-spacer>
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </template>
    </component>
</template>
<style scoped>
#share-btns-wrapper button {
    margin: 0 8px;
}
.v-btn {
    background-color: #fff;
    pointer-events: all;
}
</style>
